// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { TextList, Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGridL2STextList = class TeaserBoxInnerGridL2STextList extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            [TileSize.S]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showAuthorAvatar: false,
                showAuthorName: false,
                showCategory: false,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.S,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            },
            [TileSize.L]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
                showAuthorName: this.teaserBoxConfig.showAuthorName,
                showCategory: this.teaserBoxConfig.showCategory,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.L,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            }
        };
        this.listConfig = {
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
        this.TileSize = TileSize;
    }
};
TeaserBoxInnerGridL2STextList.moduleVersion = TeaserBoxVersion['L-2S-text-list'];
TeaserBoxInnerGridL2STextList = __decorate([
    Component({
        name: 'TeaserBoxInnerGridL2STextList',
        components: { InnerGridWrapper, TextList, Tile },
        template: `
    <InnerGridWrapper>
      <template v-if="articles && articles.length">
        <!-- Tile / L -->
        <Tile v-bind="{ ...tileConfig[TileSize.L], fallbackImage, windowService, isLazy, isMobile }" :article="articles[0]" />

        <!-- Tiles / S -->
        <Tile v-for="article in articles.slice(1, 3)" :key="article.id"
              v-bind="{ ...tileConfig[TileSize.S], article, fallbackImage, windowService, isLazy, isMobile }" />

        <!-- TextList -->
        <div class="teaser-box__list-wrapper">
          <TextList v-bind="{ readMoreLink, listConfig }" :articles="articles.slice(3, 11)" />
        </div>
      </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGridL2STextList);
export { TeaserBoxInnerGridL2STextList };
